export const FACTORS_VIEW_EVENTS = {
  VIEW_SELECTED: "View Selected",
  PERIOD_SELECTED: "Period Selected",
  DISPLAY_METRIC_SELECTED: "Display Metric Selected",
  CATEGORY_SELECTED: "Category Selected",
  SORT_CHANGED: "Sort Changed",
  TABLE_NAVIGATION_CHANGED: "Table Navigation Changed",
} as const

export type FactorsViewEventName = typeof FACTORS_VIEW_EVENTS[keyof typeof FACTORS_VIEW_EVENTS]
